export const PURCHASE_UNAVAILABLE_REASON_LOW_VALUE = "PRICE_BELOW_FEE_THRESHOLD";

export interface PurchaseEligibilityInput {
  priceGFAL?: number | null;
  isPurchasable?: boolean;
  purchaseBlockReason?: string | null;
}

export interface PurchaseEligibilityParams {
  marketplaceFeesPercent: number;
  minimumPriceUSD: number;
  gfalExRate: number;
}

export interface PurchaseEligibilityResult {
  isPurchasable: boolean;
  purchaseBlockReason?: string;
}

export const getMinimumFeeCoveredAmountGFAL = (
  priceGFAL: number,
  params: PurchaseEligibilityParams
): number => {
  if (!Number.isFinite(priceGFAL) || priceGFAL <= 0) return Number.POSITIVE_INFINITY;
  if (!Number.isFinite(params.gfalExRate) || params.gfalExRate <= 0) {
    return 0;
  }

  const minimumFeeGFAL = params.minimumPriceUSD / params.gfalExRate;
  const percentFeeGFAL = priceGFAL * (params.marketplaceFeesPercent / 100);
  return Math.max(percentFeeGFAL, minimumFeeGFAL);
};

export const getPurchaseEligibility = (
  input: PurchaseEligibilityInput,
  params: PurchaseEligibilityParams
): PurchaseEligibilityResult => {
  if (typeof input.isPurchasable === "boolean") {
    return {
      isPurchasable: input.isPurchasable,
      purchaseBlockReason: input.isPurchasable
        ? undefined
        : input.purchaseBlockReason || PURCHASE_UNAVAILABLE_REASON_LOW_VALUE,
    };
  }

  if (!Number.isFinite(input.priceGFAL ?? NaN) || (input.priceGFAL ?? 0) <= 0) {
    return {
      isPurchasable: false,
      purchaseBlockReason: PURCHASE_UNAVAILABLE_REASON_LOW_VALUE,
    };
  }

  const minimumFeeCoveredAmountGFAL = getMinimumFeeCoveredAmountGFAL(
    input.priceGFAL as number,
    params
  );
  const isPurchasable = (input.priceGFAL as number) >= minimumFeeCoveredAmountGFAL;

  return {
    isPurchasable,
    purchaseBlockReason: isPurchasable
      ? undefined
      : PURCHASE_UNAVAILABLE_REASON_LOW_VALUE,
  };
};
